import { Star } from "lucide-react";
import { Link } from "react-router-dom";
import OpenStatusBadge from "./OpenStatusBadge";
import { getCategory } from "../lib/constants";

/**
 * Compact "Top 10" card optimised for horizontal scrolling on mobile.
 *
 * Width: ~ 220px on mobile (peeks the next card) · auto on desktop grid.
 */
export default function CompactBusinessCard({ business, rank }) {
  const cat = getCategory(business.category_slug);
  return (
    <Link
      to={`/business/${business.slug}`}
      data-testid={`top-card-${business.slug}`}
      className="group flex-shrink-0 w-[220px] md:w-auto relative bg-white rounded-2xl border border-stone-200 overflow-hidden hover:shadow-lg transition-shadow"
    >
      <div className="absolute top-2 left-2 z-10 w-8 h-8 rounded-full bg-lokaso-gold text-lokaso-dark font-display font-bold text-sm flex items-center justify-center shadow">
        {rank}
      </div>
      <div
        className="aspect-[4/3] w-full flex items-center justify-center text-5xl"
        style={{ background: `${cat.color}1f`, color: cat.color }}
      >
        {business.cover_image_url ? (
          <img
            src={business.cover_image_url.startsWith("http") ? business.cover_image_url : `${process.env.REACT_APP_BACKEND_URL}${business.cover_image_url}`}
            alt={business.name}
            loading="lazy"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        ) : (
          <span>{cat.emoji}</span>
        )}
      </div>
      <div className="p-3 space-y-1.5">
        <h3 className="font-display text-base font-bold leading-tight text-lokaso-dark line-clamp-1">
          {business.name}
        </h3>
        <div className="flex items-center gap-1 text-sm">
          <Star className="w-3.5 h-3.5 text-lokaso-gold fill-lokaso-gold" />
          <span className="font-bold">{(business.avg_rating || 0).toFixed(1)}</span>
          <span className="text-stone-500 text-xs">· {business.review_count} avis</span>
        </div>
        <p className="text-xs text-stone-500 line-clamp-1">
          {business.neighborhood_name || cat.name}
        </p>
        <OpenStatusBadge hours={business.hours} />
      </div>
    </Link>
  );
}
